export function formatFlagAuditLine(label, actor) {
  if (!actor?.name) return null;
  const when = actor.at
    ? new Date(actor.at).toLocaleString(undefined, {
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit'
      })
    : '';
  return when ? `${label} ${actor.name} · ${when}` : `${label} ${actor.name}`;
}

export function flagStatusAuditLines(statusActors) {
  if (!statusActors) return [];
  const lines = [];
  const created = formatFlagAuditLine('Created by', statusActors.created);
  const addressed = formatFlagAuditLine('Addressed by', statusActors.addressed);
  const resolved = formatFlagAuditLine('Resolved by', statusActors.resolved);
  const reopened = formatFlagAuditLine('Reopened by', statusActors.reopened);
  if (created) lines.push(created);
  if (addressed) lines.push(addressed);
  if (resolved) lines.push(resolved);
  if (reopened) lines.push(reopened);
  return lines;
}
